import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//@ts-nocheck
import React, { useCallback, useState } from 'react';
import { Button as AntdButton, Flex, Button, Checkbox, Dropdown, Upload, message, } from 'antd';
import { useSelector } from 'react-redux';
import { reverseTransformData, hashMapToArray, } from '../../../shared/utils';
import Icon from '../../../components/common/Icon';
import { FilterMenuSec, LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardHead, LeftPanelContainer, PanelSearch, } from '../editor.style';
import AlphabetList from '../../../components/common/AlphabetList';
import { _downloadExcelForLocation, _uploadExcelForLocation, } from '../../../shared/httpservice/apis/location';
import { fetchLocationSiblings } from '../../../store/EditoreSlice';
import { useDispatch } from 'react-redux';
const LocationListPanel = ({ isOpen, onBack, onSelect }) => {
    const dispatch = useDispatch();
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [filteredLocationData, setFilteredLocationData] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [isTopLocation, setIsTopLocation] = useState(false);
    const [isUntagged, setIsUntagged] = useState(false);
    const [appliedFilter, setAppliedFilter] = useState({ categories: [] });
    const [searchKey, setSearchKey] = useState();
    const [uploadFileList, setUploadFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const locationSiblings = useSelector((state) => state?.editor?.locationSiblings.response);
    const locationCategories = useSelector((state) => state?.editor?.locationCategories.response);
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    const handleFilteredDataChange = useCallback((filteredData) => {
        setFilteredLocationData(filteredData);
    }, []);
    const handleCategoryChange = (checkedValues) => {
        setSelectedCategories(checkedValues);
    };
    const handleIsTopLocation = (e) => {
        setIsTopLocation(e.target.checked);
    };
    const handleIsUntagged = (e) => {
        setIsUntagged(e.target.checked);
    };
    const handleApply = () => {
        setAppliedFilter({ categories: selectedCategories, topLocation: isTopLocation, unTaggedLocation: isUntagged });
    };
    // Helper function to convert a file to a Base64 string.
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    const downloadExcelFile = async () => {
        if (siteId) {
            try {
                const response = await _downloadExcelForLocation(siteId);
                // Create a blob from the response data.
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'application/octet-stream',
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `locations.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
            catch (error) {
                console.error('Error downloading Excel file:', error);
                message.error('Error downloading file, please try again');
            }
        }
    };
    // Upload props with Base64 conversion, removal of the prefix, and file list control.
    const uploadProps = {
        accept: '.xls,.xlsx',
        maxCount: 1,
        fileList: uploadFileList,
        beforeUpload: (file) => {
            const fileExtension = file.name.split('.').pop()?.toLowerCase();
            if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
                message.error('You can only upload Excel files.');
                return Upload.LIST_IGNORE;
            }
            return false; // Prevent auto-upload.
        },
        onChange: async (info) => {
            // Update the state with the new file list.
            setUploadFileList(info.fileList);
            const latestFile = info.fileList[info.fileList.length - 1]?.originFileObj;
            if (latestFile) {
                try {
                    let base64 = await getBase64(latestFile);
                    if (typeof base64 === 'string') {
                        // Remove the data URL prefix.
                        base64 = base64.replace(/^data:.*;base64,/, '');
                    }
                    // Process the upload immediately
                    await handleUploadExcel(base64);
                }
                catch (error) {
                    console.error('Error converting file to Base64:', error);
                    message.error('File conversion failed');
                }
            }
        },
        onRemove: () => {
            setUploadFileList([]);
        },
    };
    const handleUploadExcel = async (base64Excel) => {
        if (!siteId) {
            message.error('Site ID not found');
            return;
        }
        setLoading(true);
        try {
            // Upload the Excel file.
            await _uploadExcelForLocation(siteId, { excel: base64Excel });
            message.success('Excel file uploaded successfully');
            setUploadFileList([]); // Clear the upload file list.
            //refresh the location data here
            dispatch(fetchLocationSiblings(siteId));
        }
        catch (error) {
            console.error('Error uploading Excel file:', error);
            message.error('Error uploading Excel file');
        }
        finally {
            setLoading(false);
        }
    };
    const menu = (_jsx("div", { className: "bc-dropdown", style: { width: 240 }, children: _jsx("div", { className: "bc-dropdown-menu", style: { padding: 15 }, children: _jsxs(FilterMenuSec, { children: [_jsx("h4", { children: "Filter by Categories" }), _jsx(Checkbox.Group, { options: (locationCategories || [])?.map((it) => ({
                            label: it.name,
                            value: it.categoryId,
                        })), value: selectedCategories, onChange: handleCategoryChange }), _jsx("h4", { children: "Filter by top locations" }), _jsx(Checkbox, { checked: isTopLocation, onChange: handleIsTopLocation, children: "Top Locations" }), _jsx("h4", { children: "Filter by untagged locations" }), _jsx(Checkbox, { checked: isUntagged, onChange: handleIsUntagged, children: "Untagged Locations" }), _jsx(Button, { type: "primary", style: { marginTop: 16, width: '100%' }, onClick: handleApply, children: "Apply" })] }) }) }));
    return (_jsx(LeftPanel, { style: {
            width: '320px',
        }, isOpen: isOpen, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [selectedLocations?.length > 0 ? (_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx(AntdButton, { onClick: () => {
                                            setSelectedLocations([]);
                                        }, style: { marginLeft: '-8px' }, color: "default", variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }) }), _jsx("h3", { children: selectedLocations?.length }), _jsx(AntdButton, { color: "danger", variant: "text", icon: _jsx(Icon, { icon: "trash-01", size: 18 }) })] }), _jsx(Flex, { align: "center", gap: 12, children: _jsx(Checkbox, { checked: selectedLocations?.length === filteredLocationData?.length, onChange: (e) => {
                                        if (e.target.checked) {
                                            setSelectedLocations(filteredLocationData?.map((it) => it?.id));
                                        }
                                        else {
                                            setSelectedLocations([]);
                                        }
                                    }, children: "Select All" }) })] })) : (_jsxs(LeftPanelCardHead, { children: [_jsxs(Flex, { align: "center", style: { marginBottom: 10 }, children: [_jsx("h3", { children: "Locations" }), _jsx(AntdButton, { color: 'primary', icon: _jsx(Icon, { icon: "download-cloud-01", size: 18 }), variant: "text", onClick: downloadExcelFile, title: "Download Excel" }), _jsx(Upload, { ...uploadProps, showUploadList: false, children: _jsx(AntdButton, { color: 'primary', icon: _jsx(Icon, { icon: "upload-cloud-01", size: 18 }), variant: "text", loading: loading, title: "Upload Excel" }) }), _jsx(AntdButton, { color: "primary", variant: "text", icon: _jsx(Icon, { icon: "plus-circle" }), onClick: () => {
                                            onBack();
                                        } })] }), _jsxs(Flex, { align: "center", gap: 12, children: [_jsx(PanelSearch, { placeholder: "Search Locations", variant: "filled", allowClear: true, prefix: _jsx(Icon, { icon: "search-md", size: 16 }), onChange: (e) => {
                                            setSearchKey(e.target.value);
                                        } }), _jsx(Dropdown, { trigger: ['click'], overlay: menu, placement: "bottomRight", children: _jsx(AntdButton, { icon: _jsx(Icon, { icon: "filter-funnel-01" }), type: "text" }) })] })] })), _jsx(LeftPanelCardBody, { children: _jsx(AlphabetList, { filter: appliedFilter, searchKey: searchKey, onFilteredDataChange: handleFilteredDataChange, onCheckedItemsChange: (selectedItems) => {
                                setSelectedLocations(selectedItems);
                            }, selectedItems: selectedLocations, onSelect: (id) => {
                                const find = locationSiblings?.find((it) => it.locationId === id);
                                if (find) {
                                    let payload = { ...find };
                                    if (payload.operationHours) {
                                        payload['operationHours'] = reverseTransformData(payload.operationHours);
                                    }
                                    if (payload.social) {
                                        payload['social'] = hashMapToArray(payload.social);
                                    }
                                    if (payload.phone && payload.phone.phone) {
                                        payload['phoneSource'] = payload.phone;
                                        payload['phone'] = payload.phone.phone;
                                    }
                                    else {
                                        payload['phoneSource'] = {};
                                        payload['phone'] = "";
                                    }
                                    if (payload.logoUrl) {
                                        payload['logoUrl'] = [
                                            {
                                                url: payload.logoUrl,
                                                status: 'done',
                                                uid: '-1',
                                                name: 'initial-image.jpg',
                                            },
                                        ];
                                    }
                                    if (payload.bannerUrl) {
                                        payload['bannerUrl'] = [
                                            {
                                                url: payload.bannerUrl,
                                                status: 'done',
                                                uid: '-1',
                                                name: 'initial-image.jpg',
                                            },
                                        ];
                                    }
                                    onSelect(payload);
                                }
                            }, data: (locationSiblings || [])?.map((it) => ({
                                name: it.name,
                                id: it.locationId,
                                categories: it?.categories,
                                topLocation: it?.topLocation,
                                nodeId: it?.nodeId,
                            })) }) })] }) }) }));
};
export default React.memo(LocationListPanel);
